/**
 * Dev-only pseudo-locale: English text with accented letters, wrapped in
 * brackets and padded to ~140% of its length, so clipped labels, fixed widths
 * and text that skipped the catalogue show up at a glance. `{params}` and
 * `<tags>` stay untouched so interpolation still works.
 */

const ACCENTED: Record<string, string> = {
  a: "á",
  b: "ƀ",
  c: "ç",
  d: "ð",
  e: "é",
  f: "ƒ",
  g: "ĝ",
  h: "ĥ",
  i: "î",
  j: "ĵ",
  k: "ķ",
  l: "ļ",
  m: "ɱ",
  n: "ñ",
  o: "ö",
  p: "þ",
  q: "ǫ",
  r: "ŕ",
  s: "š",
  t: "ţ",
  u: "û",
  v: "ṽ",
  w: "ŵ",
  x: "ẋ",
  y: "ý",
  z: "ž",
  A: "Á",
  B: "Ɓ",
  C: "Ç",
  D: "Ð",
  E: "É",
  F: "Ƒ",
  G: "Ĝ",
  H: "Ĥ",
  I: "Î",
  J: "Ĵ",
  K: "Ķ",
  L: "Ļ",
  M: "Ṁ",
  N: "Ñ",
  O: "Ö",
  P: "Þ",
  Q: "Ǫ",
  R: "Ŕ",
  S: "Š",
  T: "Ţ",
  U: "Û",
  V: "Ṽ",
  W: "Ŵ",
  X: "Ẋ",
  Y: "Ý",
  Z: "Ž",
};

/** Placeholders and markup tags, kept verbatim. */
const PROTECTED = /(\{[^}]+\}|<\/?[a-z][a-z0-9]*>)/;

export function pseudoLocalize(text: string): string {
  if (!text) return text;
  const accented = text
    .split(PROTECTED)
    .map((part, index) =>
      index % 2 === 1
        ? part
        : part.replace(/[A-Za-z]/g, (ch) => ACCENTED[ch] ?? ch),
    )
    .join("");
  const padding = "~".repeat(Math.max(1, Math.round(text.length * 0.4)));
  return `[${accented} ${padding}]`;
}
